import React, { Component } from "react";

import { Link, Redirect } from "react-router-dom";

import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";
import SelectExercises from "./SelectExercises";

import { setDirect } from "../store/actions/authActions";

import ReactGA from "react-ga";

import ABS from "../assets/workouts/abs.svg";
import ARM from "../assets/workouts/arm.svg";
import BALL from "../assets/workouts/ball.svg";
import BUTT from "../assets/workouts/butt.svg";
import CARDIO from "../assets/workouts/cardio.svg";
import FULL from "../assets/workouts/full.svg";
import KETTLE from "../assets/workouts/kettle.svg";
import LEG from "../assets/workouts/leg.svg";
import PILATES from "../assets/workouts/pilates.svg";
import STRETCH from "../assets/workouts/stretch.svg";

import { Helmet } from "react-helmet";

//const soundEffect = new Audio();

class WorkoutInit extends Component {
  constructor() {
    super();

    this.state = {
      menuToggled: false,
      exercisesToggled: false,
      minutes: 5,
      exercises: [],
    };
  }

  componentDidMount() {}

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  setexercisesoff = (wot, arr) => {
    // console.log(this.props.selected_arr);
    //this.props.selected_arr = arr;
    this.setState({ exercisesToggled: wot, exercises: arr });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  prepareExercises = () => {
    let exer_arr =
      this.state.exercises.length < 1
        ? this.props.selected_arr
        : this.state.exercises;

    let newArr = [];

    for (let ex of this.props.exercises) {
      if (exer_arr.includes(ex.name)) {
        newArr.push({
          name: ex.name,
          instructions: ex.instructions,
          formatted: ex.formatted,
        });
      }
    }

    return newArr;
  };

  render() {
    const { exercises, selected_arr, profile, categories } = this.props;
    if (JSON.parse(localStorage.getItem('isPremium')) === true) {
        profile.isPremium = true;
    }

    const cat_premium =
      categories && categories[0] ? categories[0]["isPremium"] : false;

    if (!this.props.match.params.category)
      return <Redirect to="/select-workout" />;

    return (
      <div>
        <Helmet>
          <title>
            {this.props.match.params.category.toUpperCase()} Entraînement
          </title>

          <meta
            name="description"
            content={categories && categories[0] ? categories[0].desc : null}
          />

          <meta
            property="og:url"
            content={
              "https://www.boxfit-fitness.com/start-workout/" +
              this.props.match.params.category
            }
          />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content={categories && categories[0] ? categories[0].desc : null}
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://www.boxfit-fitness.com/images/sharer.png"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />
          {this.state.exercisesToggled ? (
            <SelectExercises
              cat={this.props.match.params.category}
              exercises={exercises}
              off={this.setexercisesoff}
              selected={
                this.state.exercises.length > 0
                  ? this.state.exercises
                  : selected_arr
              }
            />
          ) : null}

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div
          className="Screen"
          style={
            {
              /*height: "800px",
            width: "450px",
            borderRadius: "20px",
            boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",
            backgroundColor: "#000",*/
            }
          }
        >
          <div style={{ padding: "70px 20px 20px 20px" }}>
            <h2>
              <img
                src={
                  this.props.match.params.category === "abs"
                    ? ABS
                    : this.props.match.params.category === "arm"
                    ? ARM
                    : this.props.match.params.category === "ball"
                    ? BALL
                    : this.props.match.params.category === "butt"
                    ? CARDIO
                    : this.props.match.params.category === "cardio"
                    ? BUTT
                    : this.props.match.params.category === "full"
                    ? FULL
                    : this.props.match.params.category === "kettle"
                    ? KETTLE
                    : this.props.match.params.category === "leg"
                    ? LEG
                    : this.props.match.params.category === "pilates"
                    ? PILATES
                    : this.props.match.params.category === "stretch"
                    ? STRETCH
                    : null
                }
                style={{
                  width: "40px",
                  borderRadius: "3px",
                  verticalAlign: "middle",
                }}
                alt={this.props.match.params.category + " workout"}
              />
              &nbsp;
              <font
                style={{
                  color: "#69C9D0",
                }}
              >
                {this.props.match.params.category.toUpperCase()}
              </font>{" "}
              Session entraînement
            </h2>

            <div className="wrappert">
              <select
                style={{
                  width: "100%",
                  height: "50px",
                  fontSize: "18px",
                  padding: "5px",
                }}
                id="minutes"
                onChange={this.handleChange}
                value={this.state.minutes}
              >
                <option value="5">5 minutes</option>
                <option value="8" disabled={!profile.isPremium ? true : false}>
                  8 minutes (Premium)
                </option>
                <option value="10" disabled={!profile.isPremium ? true : false}>
                  10 minutes (Premium)
                </option>
              </select>
            </div>

            {!profile.isPremium && cat_premium ? (
              categories && (
                <p style={{ fontSize: "18px" }}>
                  <button
                    disabled={true}
                    style={{
                      fontSize: "18px",
                      borderColor: "#69C9D0",
                      backgroundColor: "#000",
                      padding: "10px",
                      border: "1px solid",
                      borderRadius: "4px",
                      fontWeight: "600",
                      width: "100%",
                      color: "white",
                    }}
                  >
                    This Workout is for Premium Members Only
                  </button>
                </p>
              )
            ) : (
              <p style={{ fontSize: "18px" }}>
                <button
                  onClick={() => {
                    this.setState({ exercisesToggled: true });
                  }}
                  style={{
                    fontSize: "18px",
                    borderColor: "#69C9D0",
                    backgroundColor: "#000",
                    padding: "10px",
                    border: "1px solid",
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                  }}
                >
                  <span role="img" aria-label="like">
                    👉
                  </span>{" "}
                  {this.state.exercises.length < 1
                    ? 10
                    : this.state.exercises.length}{" "}
                  Exercices Selectionnés
                </button>
              </p>
            )}

            <p
              style={{
                fontSize: "20px",
                textAlign: "left",
                margin: "30px 0px",
              }}
            >
              {categories && categories[0] ? categories[0].desc : null}
            </p>

            {!profile.isPremium && cat_premium ? (
              <p style={{ fontSize: "18px" }}>
                <button
                  style={{
                    fontSize: "18px",
                    background: "#EE1D52",
                    padding: "10px",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                  }}
                  onClick={() => {
                    // console.log(this.prepareExercises());

                    this.props.history.push({
                      pathname: "/upgrade",
                    });
                  }}
                >
                  Try Premium for Free{" "}
                  <span role="img" aria-label="like">
                    🔥
                  </span>
                </button>
              </p>
            ) : (
              <p style={{ fontSize: "18px" }}>
                <button
                  style={{
                    fontSize: "18px",
                    background: "#69C9D0",
                    padding: "10px",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                  }}
                  onClick={() => {
                    ReactGA.event({
                      category: "User",
                      action: "Started Workout",
                    });
                    this.props.audio.play();
                    this.props.setDirect();
                    this.props.history.push({
                      pathname: "/workout",
                      state: {
                        exercises: this.prepareExercises(),
                        minutes: this.state.minutes,
                        category: this.props.match.params.category,
                        //audio: soundEffect,
                      },
                    });
                  }}
                >
                  Commencer entraînement{" "}
                  <span role="img" aria-label="like">
                    🔥
                  </span>
                </button>
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const quantiInCat = (arr, cat) => {
  let quanti = 0;
  let quanti_premium = 0;

  for (let val of arr) {
    if (val.cat === cat) {
      if (val.isPremium) {
        quanti_premium++;
        continue;
      }
      quanti++;
      continue;
    }
  }
  return [quanti, quanti_premium];
};

const mapStateToProps = (state, props) => {
  let category = props.match.params.category;
  let categories = state.firestore.ordered["categories"];
  let category_arr = categories ? categories : [];

  if (category === "full") {
    let exercises = state.firestore.ordered["exercises"];

    let newexercises = [];
    let selected_arr = [];

    if (exercises) {
      for (let val of exercises) {
        if (val.cat === "abs" && quantiInCat(newexercises, "abs")[0] <= 9) {
          if (val.isPremium && quantiInCat(newexercises, "abs")[1] <= 3) {
            newexercises.push(val);
          } else if (
            !val.isPremium &&
            quantiInCat(newexercises, "abs")[0] <= 6
          ) {
            newexercises.push(val);
          }
        } else if (
          val.cat === "leg" &&
          quantiInCat(newexercises, "leg")[0] <= 9
        ) {
          if (val.isPremium && quantiInCat(newexercises, "leg")[1] <= 3) {
            newexercises.push(val);
          } else if (
            !val.isPremium &&
            quantiInCat(newexercises, "leg")[0] <= 6
          ) {
            newexercises.push(val);
          }
        } else if (
          val.cat === "cardio" &&
          quantiInCat(newexercises, "cardio")[0] <= 9
        ) {
          if (val.isPremium && quantiInCat(newexercises, "cardio")[1] <= 3) {
            newexercises.push(val);
          } else if (
            !val.isPremium &&
            quantiInCat(newexercises, "cardio")[0] <= 6
          ) {
            newexercises.push(val);
          }
        } else if (
          val.cat === "butt" &&
          quantiInCat(newexercises, "butt")[0] <= 9
        ) {
          if (val.isPremium && quantiInCat(newexercises, "butt")[1] <= 3) {
            newexercises.push(val);
          } else if (
            !val.isPremium &&
            quantiInCat(newexercises, "butt")[0] <= 6
          ) {
            newexercises.push(val);
          }
        }
      }

      let selected = 0;
      let index = 0;
      for (let val2 of newexercises) {
        if (!val2.isPremium && selected <= 9) {
          selected_arr.push(newexercises[index]["name"]);
          selected++;
        }
        index++;
      }
    }

    let exercise = newexercises ? newexercises : [];

    //console.log(exercise);

    return {
      exercises: exercise,
      selected_arr: selected_arr,
      auth: state.firebase.auth,
      profile: state.firebase.profile,
      categories: category_arr,
      audio: state.auth.audio,
    };
  } else {
    let exercises = state.firestore.ordered["exercises"];
    let selected_arr = [];

    if (exercises) {
      let selected = 0;
      let index = 0;
      for (let val of exercises) {
        if (
          !val.isPremium &&
          selected <= 9 &&
          !state.firebase.profile.isPremium
        ) {
          selected_arr.push(exercises[index]["name"]);
          selected++;
        } else if (
          val.isPremium &&
          selected <= 9 &&
          state.firebase.profile.isPremium
        ) {
          selected_arr.push(exercises[index]["name"]);
          selected++;
        }
        index++;
      }
    }

    let exercise = exercises ? exercises : [];

    //console.log(exercise);
  if (JSON.parse(localStorage.getItem('isPremium')) === true) {
    state.firebase.profile.isPremium = true;
  }
    return {
      exercises: exercise,
      selected_arr: selected_arr,
      auth: state.firebase.auth,
      profile: state.firebase.profile,
      categories: category_arr,
      audio: state.auth.audio,
    };
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDirect: () => dispatch(setDirect()),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: "categories",
      where: [["name", "==", props.match.params.category]],
    },
    {
      collection: "exercises",
      where:
        props.match.params.category !== "full"
          ? [["cat", "==", props.match.params.category]]
          : [["cat", "!=", props.match.params.category]],
      orderBy:
        props.match.params.category !== "full"
          ? [["isPremium", "desc"]]
          : [
              ["cat", "desc"],
              ["isPremium", "asc"],
            ],
    },
  ])
)(WorkoutInit);

//export default connect(mapStateToProps, mapDispatchToProps)(WorkoutInit);
